import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';

import { HomeComponent } from './home/home.component';
import { HomeLivingPnwComponent } from './home-living-pnw/home-living-pnw.component';
import { MovingSeattleComponent } from './moving-seattle/moving-seattle.component';
import { ImportCivicComponent } from './import-civic/import-civic.component';
import { HomeEngineeringCodingComponent } from './home-engineering-coding/home-engineering-coding.component';
import { AdventOfCodeComponent } from './advent-of-code/advent-of-code.component';

import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';

const routes: Routes = [
    { path: '', redirectTo: '/import-civic', pathMatch: 'full' },
    { path: 'home', component: HomeComponent },
    { path: 'home-living-pnw', component: HomeLivingPnwComponent },
    { path: 'moving-seattle', component: MovingSeattleComponent },
    { path: 'moving-seattle/:section', component: MovingSeattleComponent },
    { path: 'import-civic', component: ImportCivicComponent },
    { path: 'import-civic/:section', component: ImportCivicComponent },
    { path: 'home-engineering-coding', component: HomeEngineeringCodingComponent },
    { path: 'advent-of-code', component: AdventOfCodeComponent },
    { path: 'privacy-policy', component: PrivacyPolicyComponent },
    { path: '**', component: PageNotFoundComponent },
];

@NgModule({
    imports: [CommonModule, RouterModule.forRoot(routes)],
    exports: [RouterModule],
    declarations: [],
})
export class AppRoutingModule {}



// WEBPACK FOOTER //
// /Users/masonpimentel/Repos/mason-blog/src/app/app-routing.module.ts